import styled from "styled-components";
export const Link = styled.a `
  color: blue;
  font-size: 1rem;
`;
